import $ from 'jquery';
import throttle from 'lodash.throttle';

const $toggleButtons = $('.js_toggle');

/**
 *
 * @param {JQuery} $button Кнопка, которая переключает контент
 * @param {String} showText Текст, который призывает раскрыть список
 * @param {String} hideText Текст, который призывает скрыть список
 */
const updateButton = ($button, showText, hideText) => {
    if ($button.text().trim() === showText) {
        $button.text(hideText).addClass('active');
    } else {
        $button.text(showText).removeClass('active');
    }
};

const init = () => {
    window.addEventListener(
        'resize',
        throttle(() => {
            if (window.innerWidth > 767) {
                $toggleButtons.each(function() {
                    if ($(this).attr('data-target')) {
                        $(`[data-name="${$(this).attr('data-target')}"]`).removeAttr('style');
                    } else {
                        $(this)
                            .prev()
                            .removeAttr('style');
                    }
                });
            }
        }, 200)
    );

    if (window.innerWidth <= 767) {
        // $toggleButtons.filter('[data-toggle-type="partial"]').each(function() {
        //     const $this = $(this);
        //     const $target = $(`[data-name="${$this.attr('data-target')}"]`);
        //     const numberToDisplay = parseInt($this.attr('data-toggle-show-count'));
        //
        //     if ($target.length) {
        //         const maxHeight = $target[0].scrollHeight;
        //         let currentMaxHeight = 0;
        //         let itemsHeight = 0;
        //
        //         $target.children().each(function(index) {
        //             itemsHeight += this.offsetHeight;
        //
        //             if (index < numberToDisplay) {
        //                 currentMaxHeight += this.offsetHeight;
        //             }
        //         });
        //
        //         currentMaxHeight +=
        //             ((maxHeight - itemsHeight) / ($target[0].childElementCount - 1)) * (numberToDisplay - 1);
        //
        //         $target
        //             .css({
        //                 'max-height': `${currentMaxHeight}px`
        //             })
        //             .attr('data-toggle-min-height', currentMaxHeight);
        //     }
        // });
    }

    $toggleButtons.on('click', function() {
        const $this = $(this);

        if ($this.attr('data-toggle-type') === 'toggle') {
            if ($this.attr('data-target')) {
                $(`[data-name="${$this.attr('data-target')}"]`).slideToggle(700, 'swing', () => {
                    updateButton($this, $this.attr('data-toggle-show-text'), $this.attr('data-toggle-hide-text'));
                });
            } else {
                $this.prev().slideToggle(700, 'swing', () => {
                    updateButton($this, $this.attr('data-toggle-show-text'), $this.attr('data-toggle-hide-text'));
                });
            }
        } else if ($this.attr('data-toggle-type') === 'hide') {
            if ($this.attr('data-target')) {
                $this.hide();
                $(`[data-name="${$this.attr('data-target')}"]`).slideDown(700);
            } else {
                $this
                    .hide()
                    .prev()
                    .slideDown(700);
            }
        } else if ($this.attr('data-toggle-type') === 'partial') {
            const $target = $(`[data-name="${$this.attr('data-target')}"]`);

            if ($target.length) {
                if (!$this.hasClass('active')) {
                    $(`[data-name="${$this.attr('data-target')}"]`).animate(
                        {
                            'max-height': `${$target[0].scrollHeight}px`
                        },
                        700,
                        'swing',
                        () => {
                            updateButton(
                                $this,
                                $this.attr('data-toggle-show-text'),
                                $this.attr('data-toggle-hide-text')
                            );
                        }
                    );
                } else {
                    $(`[data-name="${$this.attr('data-target')}"]`).animate(
                        {
                            'max-height': `${$target.attr('data-toggle-min-height')}px`
                        },
                        700,
                        'swing',
                        () => {
                            updateButton(
                                $this,
                                $this.attr('data-toggle-show-text'),
                                $this.attr('data-toggle-hide-text')
                            );
                        }
                    );
                }
            }
        }
    });
};

export default init();
